import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { IngredientsDataService, IngredientsColumnsService, RecipesDataService } from '../../../services';
import { Ingredient, IngredientsResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-ingredient-form',
  templateUrl: './ingredient-form.component.html',
  styleUrls: ['./ingredient-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class IngredientFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public ingredient: Ingredient = {};
  public ingredientForm: FormGroup = new FormGroup({});
  public ingredients: Ingredient[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'fr';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;
  public recipes: [] = [];
  formData = new FormData();

  private filerDialog: DynamicDialogRef = new DynamicDialogRef();
  public recipeValue:any;
  selectedFile: File | null;
  public recipe: any;

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private ingredientsDataService: IngredientsDataService,
    public ingredientsColumnsService: IngredientsColumnsService,
    public recipesDataService: RecipesDataService
  ) {
    this.selectedFile = null; // Initialize it to a default value, such as null

  }

  ngOnInit(): void {
    console.log('ngOnInit', 'IngredientFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Ingredient - Edit');
        this.getIngredient(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.ingredient !== 'undefined') {
      this.ingredient = this.dynamicDialogConfig.data.ingredient;
    }
    if (typeof this.ingredient.id === 'undefined' || this.ingredient.id === null) {
      this.ingredient.id = null;
    }
    this.getIngredients();
    this.prepareFrom();
    this.getRecipes();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'IngredientFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'IngredientFormComponent');
  }
  getRecipes(): void {
    this.isLoading = true;
 
    this.recipesDataService.getAllRecipes().subscribe((response) => {
      this.isLoading = false;
      if (response !== null) {
        this.recipes = response.success.data;
      }
    }, (error: any) => {;
      this.isLoading = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('UI.ERROR'), detail: this.translate.instant('UI.ApplicationSNOTLOADED')});
    });
  }
  
  getIngredient(id: number): void {
    this.isLoading = true;
    this.ingredientsDataService.getIngredient(id).subscribe((response: Ingredient|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.ingredient = response;
        this.prepareFrom();
      }
    });
  }
  onChange(e: any) {
    const selectedRecipe = e.value;
    this.recipe = e.value;

    console.log('Selected Recipe:', selectedRecipe,this.recipe);
    
    // Ensure you are storing only the id
    if (selectedRecipe && selectedRecipe.id) {
      this.ingredientForm.patchValue({ recipe: selectedRecipe });
    }
    console.log('Form after patching recipe id:', this.ingredientForm.value);
  }


  
  getIngredients(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.ingredients !== 'undefined' && this.dynamicDialogConfig.data.ingredients.length > 0) {
      this.ingredients = this.dynamicDialogConfig.data.ingredients;
      return;
    }
    this.ingredientsDataService.getIngredients(this.parameters).subscribe((response: IngredientsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.ingredients = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.ingredientForm = new FormGroup({
      id: new FormControl(this.ingredient.id, []),
      name: new FormControl(this.ingredient.name, [Validators.required]),
      nameAr: new FormControl(this.ingredient.nameAr, []),
      nameFr: new FormControl(this.ingredient.nameFr, []),
      nameEn: new FormControl(this.ingredient.nameEn, []),
      imagePath: new FormControl(this.ingredient.imagePath, []),
      unit: new FormControl(this.ingredient.unit, []),
      quantity: new FormControl(this.ingredient.quantity, []),
      recipe: new FormControl(this.recipeValue, [Validators.required]),

    });
  }
  

  

  list() {
    this.router.navigate(['/ingredients']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.ingredientForm.controls).forEach((field: any) => {
        const control = this.ingredientForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.ingredientForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.ingredient = this.ingredientForm.value;  // Get the form values
  
    // Disable submit to prevent multiple submissions
    this.disableSubmit = true;
    
    console.log('Form Data:', this.ingredientForm.value);  // Check form values before appending to formData
  
    // Reset the formData object (to clear it before appending new data)
    this.formData = new FormData();
  
    // Append other form data fields
    this.formData.append('name', this.ingredientForm.value.nameFr ?? '');
    this.formData.append('nameFr', this.ingredientForm.value.nameFr ?? '');
    this.formData.append('nameEn', this.ingredientForm.value.nameEn ?? '');
    this.formData.append('nameAr', this.ingredientForm.value.nameAr ?? '');
    this.formData.append('quantity', this.ingredientForm.value.quantity ?? '');
    this.formData.append('unit', this.ingredientForm.value.unit ?? '');
    this.formData.append('recipe', this.ingredientForm.value.recipe || '');

    // Get the selected recipe ID and append it (extract only the id)
    const recipeId = this.ingredientForm.value.recipe?.id ?? null;  // Extract only the id
    console.log('Selected Recipe ID:', recipeId, this.formData);  // Debug the value of recipe ID
  
    if (recipeId) {
      this.formData.append('recipe', recipeId.toString());
    } else {
      console.warn('No recipe selected');
    }
  
    if (this.selectedFile) {
      this.formData.append('picture', this.selectedFile);
    }
  
    // Envoie du FormData via la bonne méthode :
    this.ingredientsDataService.addIngredientWithFile(this.formData).subscribe(
      (data: any) => {
        this.disableSubmit = false;
        this.messageService.add({ severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('INGREDIENTCREATED') });
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({ refresh: true });
        } else if (redirect) {
          this.list();
        }
      },
      (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({ severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('INGREDIENTNOTCREATED') + ' ' + error.message });
        console.warn(error);
      }
    );
  
    // Continue to save or update the data
    // this.add(redirect); 
    // or 
    // this.update(redirect, this.formData);
  }
  
  add(redirect: boolean) {
    this.ingredientsDataService.addIngredient(this.ingredient).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('INGREDIENTUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('INGREDIENTNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean, data:any) {
    this.ingredientsDataService.updateIngredient(data).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('INGREDIENTCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('INGREDIENTNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.ingredientForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'ingredients',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.ingredientForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

  uploadPhoto(event: any): void {
    this.selectedFile = event.target.files[0] as File;
    if (this.selectedFile) {
      this.formData.append('imagePath', this.selectedFile);
      console.log(this.formData.append('imagePath', this.selectedFile));

    }
  }
}

@Component({
  selector: 'app-ingredient-form',
  templateUrl: './ingredient-form.component.html',
  styleUrls: ['./ingredient-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogIngredientFormComponent extends IngredientFormComponent {
}

